"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _set = _interopRequireDefault(require("lodash/set"));
var _reactDraftWysiwyg = require("react-draft-wysiwyg");
var _draftJs = require("draft-js");
var _draftjsToHtml = _interopRequireDefault(require("draftjs-to-html"));
var _htmlToDraftjs = _interopRequireDefault(require("html-to-draftjs"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _DebounceHook = _interopRequireDefault(require("../DebounceHook"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelTextEditor = props => {
  const {
    currentInitialValue = null,
    editorClassName = '',
    input,
    label = '',
    name = '',
    onFocus = () => '',
    showCountCharacters = false,
    toolbarClassName = '',
    wrapperClassName = '',
    placeholder = ''
  } = props;
  const [state, setState] = (0, _react.useState)(null);
  const [changeValue, setChangeValue] = (0, _react.useState)(true);
  const [numCharacters, setNumCharacters] = (0, _react.useState)(0);
  const debouncedSearchTerm = (0, _DebounceHook.default)(state, 500);
  (0, _react.useEffect)(() => {
    if (typeof window !== 'undefined' && input.value) {
      const contentBlock = (0, _htmlToDraftjs.default)(input.value);
      if (contentBlock && (input.value && changeValue || currentInitialValue === (0, _get.default)(input, 'value'))) {
        const contentState = _draftJs.ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = _draftJs.EditorState.createWithContent(contentState);
        setState(editorState);
        setChangeValue(false);
      }
    }
  }, [(0, _get.default)(input, 'value')]);
  (0, _react.useEffect)(() => {
    if (typeof window !== 'undefined') {
      let convertVal;
      if (state) {
        convertVal = (0, _draftjsToHtml.default)((0, _draftJs.convertToRaw)(state.getCurrentContent()));
      }
      setChangeValue(false);
      if (convertVal && (0, _get.default)(input, 'onChange') && (0, _get.default)(input, 'value') !== convertVal) {
        const tmp = document.createElement('DIV');
        tmp.innerHTML = convertVal;
        const defText = tmp.innerText.replace('\n', '');
        if (!(0, _isEmpty.default)(defText) && currentInitialValue !== null && convertVal !== '' && input.onChange) input.onChange(convertVal);else if (input.onChange) input.onChange(convertVal);
      }
      if (showCountCharacters) {
        const tmp = document.createElement('DIV');
        (0, _set.default)(tmp, 'innerHTML', convertVal);
        setNumCharacters(tmp.innerText.length - 1);
      }
    }
  }, [debouncedSearchTerm]);
  if (typeof window === 'undefined') {
    return /*#__PURE__*/_react.default.createElement("div", null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r w-perc-100"
  }, label.length > 0 && (/*#__PURE__*/_react.default.createElement("label", {
    className: "brixel-label",
    htmlFor: name
  }, label)), /*#__PURE__*/_react.default.createElement(_reactDraftWysiwyg.Editor, {
    editorState: state,
    toolbarClassName: `mt-1 brdRadius order-2 ${toolbarClassName}`,
    wrapperClassName: `brixel-text-editor dis-fl-col ${wrapperClassName}`,
    editorClassName: `brdSmall brdText100 px-2 py-1 brdRadius bgWhite order-1 ${editorClassName}`,
    onEditorStateChange: val => setState(val),
    onFocus: event => onFocus(event),
    placeholder: placeholder,
    toolbar: {
      options: ['inline', 'list', 'emoji'],
      inline: {
        options: ['bold']
      },
      list: {
        options: ['unordered', 'ordered']
      },
      emoji: {
        emojis: ['👍', '👎', '📞', '✉️', '📸', '✍', '🚪', '💰']
      }
    }
  }), showCountCharacters && (/*#__PURE__*/_react.default.createElement("small", {
    className: "countCharacters"
  }, numCharacters)));
};
var _default = exports.default = BrixelTextEditor;